// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Image({ value }) {
  return (
    <img className="image--backend" src={value.url} alt={value.title} />
  );
}

Image.propTypes = {
  value: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default Image;
